<template>
  <div class="brand-custom-fonts-container">
    <div class="back-button" @click="$emit('close')">
      <b-icon icon="arrow-left" font-scale="2" class="" />
    </div>

    <div class="model-content-wrapper">
      <div>
        <div class="cdn-url-wrapper">
          <label>URL</label>
          <input v-model="fontCDN" type="text" class="custom-font-cdn-input" />
        </div>
      </div>

      <div>
        <div>
          <input
            @change="handleFileChange"
            type="file"
            class="custom-font-file-input"
            ref="fontFileInput"
          />
          <div class="upload-button" @click="triggerFileInput">Upload</div>
        </div>
      </div>
      <div class="save-button-wrapper">
        <button type="button" @click="onSave">Add</button>
      </div>
    </div>
  </div>
</template>

<script>
import GeneralDropdown from '../core/general-dropdown.vue';
export default {
  name: 'WorkflowbrandSettingFontModal',
  data() {
    return {
      fontCDN: '',
    };
  },
  props: {
    brandings: {
      type: Object,
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.fontFileInput.click();
    },
    async handleFileChange(event) {
      this.$emit('handleFileChange', event);
    },

    onSave() {
      this.brandings.fontType = this.fontCDN;
      this.$emit('save', this.fontCDN);
    },
  },

  components: {
    GeneralDropdown,
  },
};
</script>
<style scoped>
.brand-custom-fonts-container {
  height: 100%;
  width: 100%;
  background: white;
  padding: 16px;
  z-index: 99;
}

.brand-custom-fonts-container .back-button {
  position: absolute;
  left: 16px;
  top: 16px;
  width: fit-content;
  cursor: pointer;
  z-index: 99;
}

.brand-custom-fonts-container .custom-font-cdn-input {
  color: #464d5d;
  width: 100%;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 12px;
  -webkit-font-smoothing: antialiased;
  padding: 0px 15px 0px 15px;
  border: 1px solid #dee3e9;
  box-shadow: none;
  height: 37px;
}
.brand-custom-fonts-container .model-content-wrapper {
  margin-top: 30px !important;
}

.brand-custom-fonts-container .upload-button {
  margin-top: 16px;
  padding: 0.6rem 1.6rem;
  background-color: rgb(217 217 217 / 92%);
  color: #000;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  display: inline-block;
  font-weight: 500;
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
}

.brand-custom-fonts-container .custom-font-file-input {
  display: none;
}

.brand-custom-fonts-container .save-button-wrapper button {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 8px;
  font-weight: 400;
  line-height: 23px;
  padding: 10px;
  font-size: 0.9375rem;
  margin-top: 12px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
  font-weight: 600;
  border: none;
}

.brand-custom-fonts-container .cdn-url-wrapper {
  text-align: start;
}
</style>
